import PostPDFRequestModelBase from '../_generated/modelBases/post-pdf-request-model-base';

export default class PostPDFRequestModel extends PostPDFRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
